<template>
  <div class="chart gs_container">
    <div class="superjacent">
      <p class="infoBox">
        最近一次登陆： <span class="mgr15">{{ loginTime }}</span> 地点：
        <span class="mgr15">{{ address }}</span> IP :
        <span class="mgr15">{{ Ip }}</span> 如非您本人操作，请及时
        <em @click="dialog.show = true">更改密码</em>
        <span class="mgl15" style="color"
          >系统到期时间: <i style="color: red">{{ limitTime }}</i></span
        >
      </p>
    </div>
    <div class="summaryinfo">
      <ul>
        <li>
          <div class="fr">
            <router-link
              :to="{ path: '/Home/orderplat', query: { type: 'all' } }"
              tag="div"
              class="cursor"
            >
              <p class="count">&yen;{{ orderTotalMoney.toFixed(2) }}</p>
              <p class="text">订单提交总额</p>
            </router-link>
            <div class="mgt20">
              <p class="count">&yen;{{ todayPorfit.toFixed(2) }}</p>
              <p class="text">当天平台利润</p>
            </div>
          </div>
        </li>
        <li>
          <div class="fr">
            <router-link
              :to="{ path: '/Home/orderplat', query: { type: 'waitsend' } }"
              tag="div"
              class="cursor"
            >
              <p class="count">{{ waitOrder }}</p>
              <p class="text">待发送订单</p>
            </router-link>
            <div class="mgt20">
              <p class="count">{{ register }}</p>
              <p class="text">注册商户数</p>
            </div>
          </div>
        </li>
        <li>
          <div class="fr">
            <router-link
              :to="{ path: '/Home/orderplat' }"
              tag="div"
              class="cursor"
            >
              <p class="count">{{ todayOrder }}</p>
              <p class="text">今日订单数</p>
            </router-link>
            <div class="mgt20">
              <p class="count">&yen;{{ todayMoney.toFixed(2) }}</p>
              <p class="text">今日成交额</p>
            </div>
          </div>
        </li>
        <li>
          <div class="fr">
            <router-link
              :to="{ path: '/Home/orderplat', query: { type: 'yesterday' } }"
              tag="div"
              class="cursor"
            >
              <p class="count">{{ yesterdayOrder }}</p>
              <p class="text">昨日订单数</p>
            </router-link>
            <div class="mgt20">
              <p class="count">&yen;{{ yesterdayMoney.toFixed(2) }}</p>
              <p class="text">昨日成交额</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="fluctuate" id="chartid">
      <div id="myChart1"></div>
      <div id="myChart2"></div>
      <div id="myChart3"></div>
      <div id="myChart4"></div>
    </div>
    <!-- 修改密码弹框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialog.show"
      @close="dialoginit"
      custom-class="gs_dialog"
      width="470px"
    >
      <div class="dialoglist">
        <ul>
          <li class="clearfix">
            <span class="tit">旧密码</span>
            <span class="txtbox">
              <el-input type="password" v-model="dialog.oldPassword"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class="tit">新密码</span>
            <span class="txtbox">
              <el-input type="password" v-model="dialog.newPassword"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class="tit">确认密码</span>
            <span class="txtbox">
              <el-input
                type="password"
                v-model="dialog.surePassword"
              ></el-input>
            </span>
          </li>
        </ul>
      </div>
      <div class="button_center">
        <el-button size="small" type="primary" @click="passwordSubmit"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
var elementResizeDetectorMaker = require('element-resize-detector');
export default {
  data() {
    return {
      loginTime: '', // 最近一次登陆时间
      limitTime: '', // 系统最后日期
      address: '', // 地点
      Ip: '', // 登录的ip
      orderTotalMoney: 0, // 订单提交总额
      todayPorfit: 0, // 当天平台利润
      waitOrder: 0, // 待发送订单
      register: 0, // 注册商户数
      todayOrder: 0, // 今日订单数
      todayMoney: 0, // 今日成交额
      yesterdayOrder: 0, // 昨日订单数
      yesterdayMoney: 0, // 昨日成交额
      dialog: {
        show: false, // 弹框的显隐
        oldPassword: '', // 旧密码
        newPassword: '', // 新密码
        surePassword: '' // 确认密码
      }
    };
  },
  methods: {
    getechart1() {
      let myChart1 = this.$echarts.init(document.getElementById('myChart1'));
      this.$api.chart
        .chart1()
        .then((data) => {
          if (data.status === 200) {
            let datalist = data.data;
            let option1 = {
              title: {
                text: '日时间段交易统计',
                top: 15,
                left: 20
              },
              legend: {
                top: 18,
                right: 'center',
                data: ['商户利润', '充值金额', '平台利润']
              },
              tooltip: {
                trigger: 'axis'
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                top: 55,
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  boundaryGap: false,
                  data: datalist.map((item) => item.hour)
                }
              ],
              yAxis: [
                {
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '商户利润',
                  type: 'line',
                  color: '#46C7DC',
                  smooth: true,
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: '#73cef6'
                        },
                        {
                          offset: 0.5,
                          color: '#9adcf9'
                        },
                        {
                          offset: 1,
                          color: '#fdfefe'
                        }
                      ],
                      false
                    )
                  },
                  data: datalist.map((item) => item.merchantProfit)
                },
                {
                  name: '充值金额',
                  type: 'line',
                  color: '#f89338',
                  smooth: true,
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: '#f9b273'
                        },
                        {
                          offset: 0.5,
                          color: '#f9d9bc'
                        },
                        {
                          offset: 1,
                          color: '#fcfbfb'
                        }
                      ],
                      false
                    )
                  },
                  data: datalist.map((item) => item.payAmount)
                },
                {
                  name: '平台利润',
                  type: 'line',
                  color: '#a555b7',
                  smooth: true,
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: '#de90f0'
                        },
                        {
                          offset: 0.5,
                          color: '#ecbef7'
                        },
                        {
                          offset: 1,
                          color: '#f9f2fa'
                        }
                      ],
                      false
                    )
                  },
                  data: datalist.map((item) => item.platformProfit)
                }
              ]
            };
            myChart1.setOption(option1);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    getechart2() {
      let myChart2 = this.$echarts.init(document.getElementById('myChart2'));
      this.$api.chart
        .chart2()
        .then((data) => {
          if (data.status === 200) {
            let datalist = data.data;
            let option2 = {
              title: {
                text: '近十五日交易统计',
                top: 15,
                left: 20
              },
              legend: {
                top: 18,
                left: 'center',
                data: ['商户利润', '充值金额', '平台利润']
              },
              tooltip: {
                trigger: 'axis'
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                top: 55,
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  boundaryGap: false,
                  data: datalist.map((item) => {
                    return item.date;
                  })
                }
              ],
              yAxis: [
                {
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '商户利润',
                  type: 'line',
                  color: '#46C7DC',
                  smooth: true,
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: '#73cef6'
                        },
                        {
                          offset: 0.5,
                          color: '#9adcf9'
                        },
                        {
                          offset: 1,
                          color: '#fdfefe'
                        }
                      ],
                      false
                    )
                  },
                  data: datalist.map((item) => {
                    return item.merchantProfit;
                  })
                },
                {
                  name: '充值金额',
                  type: 'line',
                  color: '#f89338',
                  smooth: true,
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: '#f9b273'
                        },
                        {
                          offset: 0.5,
                          color: '#f9d9bc'
                        },
                        {
                          offset: 1,
                          color: '#fcfbfb'
                        }
                      ],
                      false
                    )
                  },
                  data: datalist.map((item) => {
                    return item.payAmount;
                  })
                },
                {
                  name: '平台利润',
                  type: 'line',
                  color: '#a555b7',
                  smooth: true,
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: '#de90f0'
                        },
                        {
                          offset: 0.5,
                          color: '#ecbef7'
                        },
                        {
                          offset: 1,
                          color: '#f9f2fa'
                        }
                      ],
                      false
                    )
                  },
                  data: datalist.map((item) => {
                    return item.platformProfit;
                  })
                }
              ]
            };
            myChart2.setOption(option2);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    getechart3() {
      let myChart3 = this.$echarts.init(document.getElementById('myChart3'));
      this.$api.chart
        .chart3()
        .then((data) => {
          if (data.status === 200) {
            let datalist = data.data;
            let option3 = {
              title: {
                text: '商户日交易占比统计',
                top: 20,
                left: 'center'
              },
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
              },
              color: ['#46c7dc', '#f89338', '#a555b7'],
              legend: {
                orient: 'vertical',
                right: 20,
                top: 50,
                data: datalist.map((item) => {
                  return item.merchantAccount;
                })
              },
              series: [
                {
                  name: '支付金额(单位：元)',
                  type: 'pie',
                  radius: ['45%', '70%'],
                  center: ['40%', '55%'],
                  avoidLabelOverlap: false,
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold'
                      }
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: datalist.map((item) => {
                    return {
                      value: item.amount,
                      name: item.merchantAccount
                    };
                  })
                }
              ]
            };
            myChart3.setOption(option3);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    getechart4() {
      let myChart4 = this.$echarts.init(document.getElementById('myChart4'));
      this.$api.chart
        .chart4()
        .then((data) => {
          if (data.status === 200) {
            let datalist = data.data;
            let option4 = {
              title: {
                text: '商户日交易统计',
                top: 15,
                left: 10
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },
              color: ['#46c7dc', '#f89338', '#a555b7'],
              legend: {
                data: ['商户利润', '充值金额', '平台利润'],
                align: 'right',
                top: 15
              },
              grid: {
                top: 70,
                left: '3%',
                right: '4%',
                bottom: '20',
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  data: datalist.map((item) => {
                    return item.productTypeName;
                  })
                }
              ],
              yAxis: [
                {
                  type: 'value',
                  axisLabel: {
                    formatter: '{value}'
                  }
                }
              ],
              series: [
                {
                  name: '商户利润',
                  type: 'bar',
                  data: datalist.map((item) => {
                    return item.merchantProfit;
                  })
                },
                {
                  name: '充值金额',
                  type: 'bar',
                  data: datalist.map((item) => {
                    return item.payAmount;
                  })
                },
                {
                  name: '平台利润',
                  type: 'bar',
                  data: datalist.map((item) => {
                    return item.platformProfit;
                  })
                }
              ]
            };
            myChart4.setOption(option4);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 登录的信息
    loginLog() {
      this.$api.chart
        .loginLog()
        .then((data) => {
          if (data.status === 200) {
            this.loginTime = data.data.dateTime;
            this.address = data.data.location;
            this.Ip = data.data.ip;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 订单商户信息
    merchantInfo() {
      this.$api.chart
        .merchantInfo()
        .then((data) => {
          if (data.status === 200) {
            this.orderTotalMoney = data.data.amountTotal;
            this.todayPorfit = data.data.todayPlatformProfit;
            this.waitOrder = data.data.waitOrderCount;
            this.register = data.data.registerUserCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 订单金额统计信息
    MoneyInfo() {
      this.$api.chart
        .MoneyInfo()
        .then((data) => {
          if (data.status === 200) {
            this.todayOrder = data.data.todayOrderCount;
            this.todayMoney = data.data.todayPayAmount;
            this.yesterdayOrder = data.data.yesterdayOrderCount;
            this.yesterdayMoney = data.data.yesterdayPayAmount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    TodayOrderCount() {
      this.$api.chart
        .TodayOrderCount()
        .then((data) => {
          if (data.status === 200) {
            this.todayOrder = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    YesterdayOrderCount() {
      this.$api.chart
        .YesterdayOrderCount()
        .then((data) => {
          if (data.status === 200) {
            this.yesterdayOrder = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    TodayPayAmount() {
      this.$api.chart
        .TodayPayAmount()
        .then((data) => {
          if (data.status === 200) {
            this.todayMoney = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    YesterdayPayAmount() {
      this.$api.chart
        .YesterdayPayAmount()
        .then((data) => {
          if (data.status === 200) {
            this.yesterdayMoney = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框的初始化
    dialoginit() {
      this.dialog.oldPassword = '';
      this.dialog.newPassword = '';
      this.dialog.surePassword = '';
    },
    // 修改密码的提交
    passwordSubmit() {
      if (this.dialog.oldPassword === '') {
        this.$messageError('请输入旧密码！');
        return;
      } else if (this.dialog.newPassword === '') {
        this.$messageError('请输入新密码！');
        return;
      } else if (this.dialog.newPassword !== this.dialog.surePassword) {
        this.$messageError('两次新密码输入不一致，请重新输入');
        this.dialog.surePassword = '';
        return;
      }
      this.$api.chart
        .repassword({
          oldPassword: this.dialog.oldPassword,
          password: this.dialog.newPassword,
          confirmPassword: this.dialog.surePassword
        })
        .then((data) => {
          if (data.status === 200) {
            this.dialog.show = false;
            this.$messageSuccess('更改密码成功！');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 系统时间
    getLimitTime() {
      this.$api.chart
        .limitTime()
        .then((data) => {
          this.limitTime = data.data;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.loginLog();
    this.merchantInfo();
    // this.MoneyInfo();
    this.TodayOrderCount();
    this.YesterdayOrderCount();
    this.YesterdayPayAmount();
    this.TodayPayAmount();
    this.getLimitTime();
    this.$nextTick(() => {
      this.getechart1();
      this.getechart2();
      this.getechart3();
      this.getechart4();
    });
  },
  mounted() {
    var that = this;
    var erd = elementResizeDetectorMaker();
    erd.listenTo(document.getElementById('chartid'), function (element) {
      that.$nextTick(function () {
        // 使echarts尺寸重置
        that.$echarts.init(document.getElementById('myChart1')).resize();
        that.$echarts.init(document.getElementById('myChart2')).resize();
        that.$echarts.init(document.getElementById('myChart3')).resize();
        that.$echarts.init(document.getElementById('myChart4')).resize();
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.chart {
  .superjacent {
    width: 100%;
    height: 50px;
    overflow: hidden;
    .infoBox {
      padding-left: 5px;
      height: 52px;
      line-height: 52px;
      font-size: 16px;
      color: #666;
      span {
        color: #272636;
      }
      em {
        color: #e34639;
        cursor: pointer;
      }
    }
  }
  .summaryinfo {
    margin-top: 10px;
    ul {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      li {
        width: 23%;
        height: 214px;
        box-sizing: border-box;
        padding: 20px;
        background: #fff url(../../assets/images/line.png) no-repeat 0 center;
        .cursor {
          cursor: pointer;
          &:hover {
            .count {
              color: #4680d8;
            }
            .text {
              color: #999;
            }
          }
        }
        .count {
          font-size: 30px;
          color: #243054;
          text-align: center;
        }
        .text {
          font-size: 18px;
          color: #666;
          margin-top: 8px;
          text-align: center;
        }
      }
    }
  }
}
.fluctuate {
  overflow: hidden;
  margin-top: 20px;
}
#myChart1 {
  float: left;
  width: 49%;
  height: 400px;
  background-color: #fff;
}
#myChart2 {
  float: right;
  width: 49%;
  height: 400px;
  background-color: #fff;
}
#myChart3 {
  float: left;
  width: 39%;
  height: 400px;
  background-color: #fff;
  margin-top: 20px;
}
#myChart4 {
  float: right;
  width: 59%;
  height: 400px;
  background-color: #fff;
  margin-top: 20px;
}
.button_center {
  text-align: center;
  padding-bottom: 10px;
}
.dialoglist {
  ul {
    padding-left: 30px;
    li {
      margin-bottom: 10px;
      .tit {
        float: left;
        width: 100px;
        height: 30px;
        line-height: 30px;
      }
      .txtbox {
        float: left;
        width: 250px;
      }
    }
  }
}
</style>
